import GlobalLogin from './Login'

const GlobalUnicty = {
    socialLogin: GlobalLogin.socialLogin
}
export default GlobalUnicty
